import $ from 'jquery';
/**
 * Created by Kamil.Adamuszek on 2017-04-14.
 */
/**
 * Validation method that test if the field is valid against a maximum length of string.
 */
export var maxLength = function (value, element) {
    var maxValue = $(element).data('max_length');
    if (value.length >= maxValue) {
        return true;
    }
    else {
        return false;
    }
};
